export enum DeliveryOption {
  ECONOMY = "ECONOMY",
  STANDARD = "STANDARD",
  FAST = "FAST",
}
